// extracted by mini-css-extract-plugin
export var bloc = "actualite-module--bloc--01466";
export var categories = "actualite-module--categories--c32c7";
export var category = "actualite-module--category--b83e4";
export var imgBloc = "actualite-module--imgBloc--e6a12";
export var innerBloc = "actualite-module--innerBloc--cf20a";
export var linkRoot = "actualite-module--linkRoot--5818d";
export var more = "actualite-module--more--f1b2e";
export var moreContainer = "actualite-module--moreContainer--52381";
export var preview = "actualite-module--preview--57aed";
export var title = "actualite-module--title--034ca";